<!-- 图片反馈 -->
<template>
  <div class="edit" v-drag>
    <div  role="document">
    <div class="modal-content">
      <div class="modal-header" >
        <span class="modal-title">图片展示</span>
        <span aria-hidden="true" class="modal-span" @click="close">&times;</span> 
      </div>
      <div class="modal-body container" >
            <div class="wrap">
              <img  :src="src" alt="系统图片">
            </div>
            <a href="javascript:;" class="arrow arrow_left" @click="prev()">&lt;</a>
            <a href="javascript:;" class="arrow arrow_right" @click="next()">&gt;</a>
      </div>      
      <div class="modal-footer">
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      src:'',
      picture_url:'',
      num:0
    };
  },

  props:{
    rule_data:String,
  },

  components: {},

  computed: {},

  mounted(){
    this.request_picture(this.rule_data)
  },

  methods: {
    //上一页
    prev(){
      if(this.num>0){
        this.num-=1;
        this.picture_url.forEach((item,index) => {
          if(this.rule_data.match(new RegExp("^http.*$"))) {
            this.src=this.picture_url[this.num]
          }else if(this.rule_data.match(new RegExp("^https.*$"))) {
            this.src=this.picture_url[this.num]
          }else{
            this.src=this.img_url+this.picture_url[this.num]
          }          
        });
      }
    },
    //下一页
    next(){
      if(this.picture_url.length>this.num+1){        
        this.num=this.num+1;
        this.picture_url.forEach((item,index) => {
          if(this.rule_data.match(new RegExp("^http.*$"))) {
            this.src=this.picture_url[this.num]
          }else if(this.rule_data.match(new RegExp("^https.*$"))) {
            this.src=this.picture_url[this.num]
          }else{
            this.src=this.img_url+this.picture_url[this.num]
          } 
        });
      }
      
    },
    //请求图片
    request_picture(rule_data){
        this.picture_url=rule_data.split(',')
        if(rule_data.match(new RegExp("^http.*$"))){
          this.src=this.picture_url[this.num]
        }else if(rule_data.match(new RegExp("^https.*$"))){
          this.src=this.picture_url[this.num]
        }else{
          this.src=this.img_url+this.picture_url[this.num]
        }
    },
    //  关闭图标
    close(){
      this.$emit('close_project')
    },
  },
  directives: {
    drag: {
      inserted(el) {
        let drag_Box = el; //获取当前元素
        let dragBox = document.getElementsByClassName('modal-header')[0];
        dragBox.onmousedown = e => {
          //算出鼠标相对元素的位置
          let disX = e.clientX - drag_Box.offsetLeft;
          let disY = e.clientY - drag_Box.offsetTop;
          document.onmousemove = e => {
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;
            //移动当前元素
            drag_Box.style.left = left + "px";
            drag_Box.style.top = top + "px";
          };
          document.onmouseup = e => {
            //鼠标弹起来的时候不再移动
            document.onmousemove = null;
            //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
            document.onmouseup = null;
          };
        };
      }
    }
  }
}

</script>
<style scoped>
  /* * {
        margin:0;
        padding:0;
    } */
    a{
        text-decoration: none;
    }
.container {
            position: relative;
            width: 600px;
            height: 400px;
            /* margin:100px auto 0 auto; */
            /* box-shadow: 0 0 5px green; */
            overflow: hidden;
        }   
.wrap {
            position: absolute;
            width: 4200px;
            height: 400px;
            z-index: 1;
        }
.container .wrap img {
            float: left;
            width: 600px;
            height: 400px;
        }
.container .arrow {
            position: absolute;
            top: 40%;
            color: green;
            padding:0px 14px;
            border-radius: 50%;
            font-size: 50px;
            z-index: 2;
            display: none;
            text-decoration: none;
        }
        .container .arrow_left {
            left: 10px;
        }
        .container .arrow_right {
            right: 10px;
        }
        .container:hover .arrow {
            display: block;
        }
        .container .arrow:hover {
            /* background-color: rgba(0,0,0,0.2); */
        }





  .modal-header{
    cursor: move;
  }
  .modal-body{
    font-size: 12px;
    text-align: center;
    /* height: 500px; */
    /* overflow: auto; */
  }
  .edit{
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 846px;
    z-index:999;
    /* transform: translate(-40%, -40%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
  }
  .text{
    margin: 0 auto;
    display: block;
    outline: none;
    width: 100%;
    border: 1px solid #5b5d63;
  }
  .modal-header{
  	background:#ebecf0;
  	height:40px
	}
  .modal-span{
  	font-size:20px;
  	margin-top:-14px;
  	cursor:pointer
	}
  .modal-title{
  	line-height:1px
	}
  .btn-default-close{
    color:#007bff;
    font-size:12px;
  	border:1px solid #808080;
  	padding:4px;
  	/* margin-right: 90%; */
  }
  .modal-footer{
    justify-content: space-between;
  }
  .btn-default-determine{
    color:#007bff;
  	font-size:12px;
  	border: 1px solid rgb(128, 128, 128);
  	padding: 4px;
    }
</style>